import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { onboardingApi } from "@/redux/apis/onboarding/onboardingApi";
import { QuickSetupState, QuickSetupSection } from "./types";

const initialState: QuickSetupState = {
  cameFromQuickSetup: false,
  lastClickedSection: null,
  lastOpenedPanel: "1-getting-started",
  hasSeenOnboardingCompleteModal: false,
  hasSeenSimulationCompleteSnackbar: false,
  hasSeenPreSimulationModal: false,
  isOnboardingComplete: null,
};

export const quickSetupSlice = createSlice({
  name: "quickSetup",
  initialState,
  reducers: {
    setQuickSetupNavigationFlag: (state, action: PayloadAction<{ section?: QuickSetupSection }>) => {
      state.cameFromQuickSetup = true;
      state.lastClickedSection = action.payload.section || null;
    },
    resetQuickSetupNavigation: (state) => {
      state.cameFromQuickSetup = false;
      state.lastClickedSection = null;
    },
    setLastOpenedPanel: (state, action: PayloadAction<string | null>) => {
      state.lastOpenedPanel = action.payload;
    },
    setHasSeenOnboardingCompleteModal: (state, action: PayloadAction<boolean>) => {
      state.hasSeenOnboardingCompleteModal = action.payload;
    },
    setHasSeenSimulationCompleteSnackbar: (state, action: PayloadAction<boolean>) => {
      state.hasSeenSimulationCompleteSnackbar = action.payload;
    },
    setHasSeenPreSimulationModal: (state, action: PayloadAction<boolean>) => {
      state.hasSeenPreSimulationModal = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(onboardingApi.endpoints.getOnboardingStatus.matchFulfilled, (state, action) => {
      state.isOnboardingComplete = action.payload.overallCompletion.isOnboardingComplete;
    });
  },
});

export const {
  setQuickSetupNavigationFlag,
  resetQuickSetupNavigation,
  setLastOpenedPanel,
  setHasSeenOnboardingCompleteModal,
  setHasSeenSimulationCompleteSnackbar,
  setHasSeenPreSimulationModal,
} = quickSetupSlice.actions;

export default quickSetupSlice.reducer;
